import type { RowSelectionState } from '@tanstack/react-table';

export function applyRowSelectionRange(
  current: RowSelectionState,
  visibleRowIds: string[],
  fromIndex: number,
  toIndex: number
): RowSelectionState {
  const start = Math.min(fromIndex, toIndex);
  const end = Math.max(fromIndex, toIndex);
  const next: RowSelectionState = { ...current };
  for (let index = start; index <= end; index += 1) {
    const id = visibleRowIds[index];
    if (id) {
      next[id] = true;
    }
  }
  return next;
}

export function selectedRowIds(selection: RowSelectionState): string[] {
  return Object.keys(selection).filter((id) => selection[id]);
}
